import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import PrevButton from '../../../ui-components/Button/PrevButton';
import NextButton from '../../../ui-components/Button/NextButton';
import { PALETTE } from '../../../common/styles/palette';

interface IProps extends StyledComponentProps {
    next: () => any;
    prev: () => any;
    page: number;
    totalRows: number;
    rowsPerPage: number;
}
const styles = {
    container: {
        width: "100%",
        display: 'flex',
        justifyContent: 'center',
        padding: '10px',
        alignItems: "center"
    },
    pageNumber:{
        width: "30px",
        height: "30px",
        display: 'flex',
        justifyContent: 'center',
        fontWeight: "bold",
        alignItems: "center",
        backgroundColor: PALETTE.UI.Buttons.Background,
        color: 'white',
        borderRadius: "50%",
    }
}
const Comp = (props: IProps) => {
    return (<div className={props.classes.container}>
        <PrevButton onClick={props.prev} disabled={props.page === 0} />
        <span className={props.classes.pageNumber}>{props.page + 1}</span>
        <NextButton onClick={props.next} disabled={props.page >= Math.ceil(props.totalRows / props.rowsPerPage) - 1} />
    </div>)
}

export const UserPagination = withStyles(styles as any)(Comp) 